import { useState } from 'react';
import { DropdownOption } from '@salvapp/ui-components/build/dropdown/dropdown.types';
import { InternalApiCustomListSchemaFieldType } from '../../../api-internal';
import { useQueryCustomListSchemaFields } from '../../schema/customListSchemaActions';

const useUsableFieldParts = (customListId: string) => {
  const [firstSelectedPart, setFirstSelectedPart] = useState<DropdownOption>();
  const { data } = useQueryCustomListSchemaFields(customListId);
  const schemaFields = data ?? [];

  const getUsableFieldParts = (): DropdownOption[] => {
    const ARRAY_ACCESS = '[]';
    const OBJECT_ACCESS = '.';

    const availableSchemaFields = (() => {
      if (!firstSelectedPart) return schemaFields;
      if (firstSelectedPart.value.includes(ARRAY_ACCESS) && !firstSelectedPart.value.includes(OBJECT_ACCESS)) {
        return [schemaFields.find((schemaField) => schemaField.id === firstSelectedPart.key)!];
      } else if (firstSelectedPart.value.includes(OBJECT_ACCESS)) {
        const selectedParentId = schemaFields.find(
          (schemaField) => schemaField.id === firstSelectedPart.key
        )!.parentId!;

        return schemaFields.filter(
          (schemaField) => schemaField.id === selectedParentId || schemaField.parentId === selectedParentId
        );
      } else {
        return schemaFields.filter(
          (schemaField) =>
            !schemaField.isMulti &&
            !schemaField.parentId &&
            schemaField.type !== InternalApiCustomListSchemaFieldType.OBJECT
        );
      }
    })();

    return availableSchemaFields
      .filter((schemaField) => !schemaField.parentId)
      .map((schemaField) => {
        let name = schemaField.fieldName;

        if (schemaField.isMulti) {
          name += ARRAY_ACCESS;
        }
        if (schemaField.type === InternalApiCustomListSchemaFieldType.OBJECT) {
          name += OBJECT_ACCESS;
          return availableSchemaFields
            .filter((childSchemaField) => childSchemaField.parentId === schemaField.id)
            .map((childSchemaField) => {
              return {
                key: childSchemaField.id!,
                value: name + childSchemaField.fieldName,
                label: name + childSchemaField.fieldName,
              };
            });
        }
        return {
          key: schemaField.id!,
          value: name,
          label: name,
        };
      })
      .flat();
  };

  return {
    usableFieldParts: getUsableFieldParts(),
    setFirstSelectedPart,
  };
};

export default useUsableFieldParts;
